import React from "react";
import styled from "styled-components";

const MapInputContainer = styled.div`
  margin-top: 20px;
`;

const MapNameInput = styled.input`
  margin-right: 10px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const SubmitButton = styled.button`
  margin-left: 10px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

function MapDetailsForm({
  maps,
  mapNames,
  handleMapNameChange,
  handleNameSubmit
}) {
  return (
    <div>
      {maps.length > 0 &&
        maps.map((map, index) => (
          <MapInputContainer key={index}>
            <h4>Map {index + 1}</h4>
            <MapNameInput
              type="text"
              placeholder="Enter map name"
              value={mapNames[index] || ""}
              onChange={(e) => handleMapNameChange(index, e.target.value)}
            />
            <SubmitButton
              onClick={() => handleNameSubmit(index)}
              disabled={!mapNames[index]} // Disable the button if no name is entered
            >
              Submit Name
            </SubmitButton>
          </MapInputContainer>
        ))}
    </div>
  );
}

export default MapDetailsForm;
